import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { backendPostReturnPromise } from '../../helpers/callBackend';
import { errorMessage } from '../../helpers/errorMessageFunc';
import GetHelpModal from "../buttons/getHelpModal";
import AddCompanyButton from '../specific/company/addCompany';
import { Routes, Route } from "react-router-dom";
import { Stack, Typography, Box, MenuItem, IconButton, Popover, Avatar, Divider, FormControl, InputLabel, Select, ListItemIcon, Menu, Grid } from '@mui/material';
import UserOutlined from '@ant-design/icons/UserOutlined';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import GroupIcon from '@mui/icons-material/Group';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import CompanySelect from './companySelect';
import Logout from "../../layout/authenticate/logout";
import { message } from 'antd';

function TabPanel({ children, value, index, ...other }) {
    return (
      <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`} {...other}>
        {value === index && children}
      </div>
    );
}

function a11yProps(index) {
    return {
      id: `profile-tab-${index}`,
      'aria-controls': `profile-tabpanel-${index}`
    };
}

const GenericHeader = () => {
    const [companiesData, setCompaniesData] = useState(JSON.parse(localStorage.getItem("arpariCompanyListData")) || []);
    const [selectedCompany, setSelectedCompany] = useState(JSON.parse(localStorage.getItem("arpariAffiliatedCompany")) || {});
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
    const [tabValue, setTabValue] = useState(0);
    const allowSwitching = useRef(false);

    const userEmail = localStorage.getItem('psg_last_login');
    const location = useLocation();

    const onSubmitChangeCompany = (company) => {
        if (company.id === selectedCompany.id) {
            errorMessage("Cannot switch to same dashboard");
            return;
        }
        message.info(`Switching from ${selectedCompany.company_name} to ${company.company_name}`);
        const data = { landlord_id: company.id };
        backendPostReturnPromise("/api/landlord/switch/", data).then((res) => {
            if (res.status == 200) {
                allowSwitching.current = true;
                setSelectedCompany(company);
            }
        }).catch((error) => {
            errorMessage(error?.response?.data?.description);
        });
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }

    const addCompanyToDropdown = (newCompaniesData) => {
        setCompaniesData(newCompaniesData);
    };

    const handlePopoverClick = (event) => {
        setPopoverAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchorEl(null);
    };

    const openPopover = Boolean(popoverAnchorEl);
    const id = openPopover ? 'simple-popover' : undefined;

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 300,
                overflow: 'auto',
            },
        },
    };
    
    // Because settings states is async we need to use an effect to wait for selectectedCompany to be set
    useEffect(() => {
        // check allow switching so that this effect doesn't redirect on initial render
        if (!allowSwitching.current) {
            return;
        }
        window.location.href = "/login-redirect";
    }, [selectedCompany]);

    return (
        <Box sx={{ width: "100%", margin: "-16px 0px 0px 0px" }}>
            <Grid container spacing={2} sx={{ paddingBottom: 0, margin: "0px 0px 0px 20px", alignItems: 'center' }}>
                <Grid item xs={8} sm={9}>
                <CompanySelect
                    companiesData={companiesData}
                    currentCompany={selectedCompany}
                    handleCompanyChange={onSubmitChangeCompany}
                    addCompanyToDropdown={addCompanyToDropdown}
                    MenuProps={MenuProps}
                />
                </Grid>

                <Grid item xs={4} sm={3} container justifyContent="flex-end" sx={{ ml: -7 }}>
                    <IconButton aria-label="account of current user" aria-controls="simple-popover" aria-haspopup="true" onClick={handlePopoverClick}>
                        <Avatar sx={{ bgcolor: '#F1F5F8', color: "#152e4d" }}>
                            <UserOutlined />
                        </Avatar>
                    </IconButton>
                </Grid>

                <Popover
                    id={id}
                    open={openPopover}
                    anchorEl={popoverAnchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1} justifyContent="start">
                            <IconButton>
                                <Avatar sx={{ bgcolor: '#F1F5F8', color: "#152e4d" }}>
                                    <UserOutlined />
                                </Avatar>
                            </IconButton>
                            <Typography variant="h6">{userEmail}</Typography>
                            <IconButton component={Link} to="/logout" sx={{ p: 0 }}>
                                <LogoutOutlined sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Stack>
                        <Stack>
                            <Tabs variant="fullWidth" value={tabValue} onChange={handleTabChange} aria-label="profile tabs" sx={{ margin: 0, padding: 0 }}>
                                <Tab
                                    sx={{
                                        fontSize: 12,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textTransform: 'capitalize',
                                        minHeight: 30,
                                        mb: -5,
                                        p: 0,
                                    }}
                                    icon={<UserOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                                    label="Profile"
                                    {...a11yProps(0)}
                                />
                                {/* <Tab
                                    sx={{
                                        fontSize: 12,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textTransform: 'capitalize',
                                        minHeight: 30,
                                        mb: -5,
                                        p: 0,
                                    }}
                                    icon={<SettingOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                                    label="Setting"
                                    {...a11yProps(1)}
                                /> */}
                            </Tabs>
                        </Stack>
                        <Stack direction="column" spacing={2} sx={{ mt: 1 }}>
                            <TabPanel value={tabValue} index={0}>
                                <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: 1 }}>
                                    <Link variant="fullWidth" to="/team" passHref style={{ width: '100%' }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <ListItemIcon><GroupIcon /></ListItemIcon>
                                            <Typography variant="body1" sx={{ textTransform: 'none', color: 'secondary.main' }}>Team</Typography>
                                        </Stack>
                                    </Link>
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: 1 }}>
                                    <Link to="/account" passHref style={{ width: '100%' }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <ListItemIcon><UserOutlined /></ListItemIcon>
                                            <Typography variant="body1" sx={{ textTransform: 'none', color: 'secondary.main' }}>Profile</Typography>
                                        </Stack>
                                    </Link>
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: 1 }}>
                                    <GetHelpModal />
                                </Stack>
                            </TabPanel>
                            {/* <TabPanel value={tabValue} index={1}>
                                // settings tab items go here
                            </TabPanel> */}
                        </Stack>
                    </Box>
                </Popover>
            </Grid>
            <Divider style={{ margin: 0 }} />
        </Box>
    );
};

export default GenericHeader;
